import React, { useEffect } from 'react';
import {
  initInbox,
  removeChatwootWidget,
  setUserProperties
} from "common/ChatwootHelper";
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { get } from "lodash";
import config from "common/config";

const ChatwootWidget = ({
                          isAuthenticated,
                          id,
                          email,
                          role,
                          newPrimaryLanguage,
                          status,
                          displayName
                        }) => {
  const {pathname} = useLocation();
  const [showHelpCenter, setShowHelpCenter] = React.useState(true);
  const [scriptLoaded, setScriptLoaded] = React.useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = `${config.CHATWOOT_BASEURL}/packs/js/sdk.js`;
    document.head.appendChild(script);
    script.onload = () => {
      setScriptLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      const isChatInUse = get(status, 'experiences.chattype') === 'use';
      const isAiChatActive = get(status, 'experiences.chatStatus.aiChat') === 'use';
      const isHelpCenterActive = get(status, 'experiences.chatStatus.helpCenter') === 'use';
      // AI assist takes the corner outright where it is on. Where it is off the
      // help centre gets every tab but the post-match one, whose own chat sits
      // in the same corner.
      const isPostMatchTab = pathname.startsWith('/mentorship');
      setShowHelpCenter(isChatInUse && isHelpCenterActive && !isAiChatActive && !isPostMatchTab);
    } else {
      setShowHelpCenter(true);
    }
    // `status` lands after the session is restored, so keying this on
    // isAuthenticated alone leaves the widget on for an AI-assist user.
  }, [isAuthenticated, status, pathname]);

  React.useEffect(() => {
    // console.log( 'scriptLoaded', scriptLoaded, 'showHelpCenter', showHelpCenter, 'isAuthenticated', isAuthenticated);
    if (scriptLoaded && showHelpCenter) {
      if (isAuthenticated) {
        setUserProperties({id: id.toString(), email, role, newPrimaryLanguage, displayName})
      } else {
        initInbox();
      }
    } else {
      removeChatwootWidget();
    }
  }, [scriptLoaded, showHelpCenter, isAuthenticated]);

  return null;
}

const mapStateToProps = ({
                           auth: {isAuthenticated, user: {id, email, role, newPrimaryLanguage, status}},
                           profile: {displayName}
                         }) => {
  return {
    isAuthenticated,
    id,
    email,
    role,
    newPrimaryLanguage,
    status,
    displayName
  }
};

export default connect(mapStateToProps)(ChatwootWidget);
